module.exports = __webpack_public_path__ + "img/ic_info.7963785d.svg";